import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { LOGO_BASE64 } from '../utils/logoData';

const navItems = [
  { label: '首页', href: '#home' },
  { label: '产品模块', href: '#products' },
  { label: '应用场景', href: '#scenarios' },
  { label: '关于我们', href: '#about' },
  { label: '核心优势', href: '#advantages' },
  { label: '联系我们', href: '#contact' },
];

const LOGO_URL = LOGO_BASE64;

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className={`h-10 w-auto rounded-lg p-1 transition-all duration-300 ${isScrolled ? 'bg-slate-100' : 'bg-transparent'}`}>
              <img 
                src={LOGO_URL} 
                alt="郑州博乐" 
                className="h-full w-auto object-contain"
              />
            </div>
            <div className="flex flex-col">
              <span className={`font-bold text-lg leading-tight ${isScrolled ? 'text-slate-900' : 'text-white'}`}>
                船运发货一码通
              </span>
              <span className={`text-xs ${isScrolled ? 'text-slate-500' : 'text-white/80'}`}>
                郑州博乐信息技术有限公司
              </span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <button
                key={item.href}
                onClick={() => scrollToSection(item.href)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  isScrolled
                    ? 'text-slate-600 hover:text-ocean-600 hover:bg-ocean-50'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <button
              onClick={() => scrollToSection('#contact')}
              className="px-6 py-2.5 bg-gradient-to-r from-ocean-500 to-primary-600 text-white font-medium rounded-lg hover:shadow-lg hover:shadow-ocean-500/30 transition-all duration-200"
            >
              免费咨询
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 rounded-lg ${
              isScrolled ? 'text-slate-600' : 'text-white'
            }`}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-slate-100 shadow-xl">
          <div className="px-4 py-4 space-y-2">
            {navItems.map((item) => (
              <button
                key={item.href}
                onClick={() => scrollToSection(item.href)}
                className="block w-full text-left px-4 py-3 text-slate-600 hover:text-ocean-600 hover:bg-ocean-50 rounded-lg font-medium transition-colors"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('#contact')}
              className="w-full mt-4 px-6 py-3 bg-gradient-to-r from-ocean-500 to-primary-600 text-white font-medium rounded-lg"
            >
              免费咨询
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
